'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const CoverImageBox = styled(Box)(({theme}) => ({
    marginBottom: 0,
    textAlign: 'center',
    borderImage: theme.palette.custom?.borderCoverImage,
    boxShadow: '-2.5px 2.5px 5px rgba(51,51,51,0.2)',
    borderImageSlice: '1',
    borderStyle: 'solid',
    borderWidth: '7.5px',
}));

export default CoverImageBox;
